import { IDeleteSelectedItemChecklistServicoUseCase } from "../../../presentation/useCases/delete/delete_selected_item_checklist_servico_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteSelectedItemChecklistServicoUseCase
 */

export class DeleteSelectedItemChecklistServicoUseCase implements IDeleteSelectedItemChecklistServicoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async deleteSelectedItemChecklistServico(
    idsChecklistServico: number[],
  ): Promise<void> {
    await this.repository.deleteSelectedItemChecklistServico(idsChecklistServico);
  }
}
